import { NgClass} from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { Tooltip } from 'primeng/tooltip';
import { AuthService } from '../../../core/services/auth.service';
import { I18nService } from '../../../core/services/i18n.service';
import { RuntimeConfigService } from '../../../core/services/runtime-config.service';
import { SpsMenuItem } from '../../../layout/interfaces/sps-menu-item';
import { SpsProfileCustomerComponent } from './sps-profile-customer/sps-profile-customer.component';

@Component({
  selector: 'sps-profile-dialog',
  imports: [
    Dialog,
    Button,
    NgClass,
    Tooltip,
    SpsProfileCustomerComponent,
    RouterLink
  ],
  templateUrl: './sps-profile-dialog.component.html'
})
export class SpsProfileDialogComponent implements OnInit, AfterViewInit {

  @Input() dialogWidth: string = '1280px';
  @Input() dialogHeight: string = '800px';
  @Input() activeProfileId: string;
  @Input() visible: boolean = false;

  @Output() dialogClose = new EventEmitter();

  /**
   * MenuItem properties of the profile-menu
   * @type {SpsMenuItem[]}
   */
  menuItems: SpsMenuItem[] = [];
  activeMenuItem: SpsMenuItem = null;
  private maxLinkIndex: number = 6;

  /**
   * All Html-Elements of the menu-item link-tags <a>
   * for keyboard focus-control
   */
  private links: HTMLLinkElement[] = [];

  /**
   * Save-Button is enabled
   */
  saveEnabled: boolean = false;
  /**
   * Dialog-Button state
   */
  showCloseButton: boolean = false;
  showCancelButton: boolean = true;
  showSaveButton: boolean = true;

  constructor(public authService: AuthService,
               public i18n: I18nService,
               private runtimeConfig: RuntimeConfigService) {
  }

  ngOnInit() {
    this.initMenuItems();
  }

  ngAfterViewInit() {
    this.links = Array.from(document.querySelectorAll('.menu-link')) as HTMLLinkElement[];
  }

  dialogClosed() {
    this.visible = false;
    this.dialogClose.emit();
  }

  private initMenuItems() {
    this.menuItems = [
      {
        id:'CUSTOMERDATA',
        i18nLabelKey: 'CUSTOMERDATA',
        label: this.i18n.i18nLng()['CUSTOMERDATA'],
        // icon: 'pi pi-user',
        linkIndex: 0,
        active: this.activeProfileId === 'CUSTOMERDATA',
      },
      /** currently disabled -> change LinkIndex on reactivation
      {
        id:'USERSANDTEAM',
        i18nLabelKey: 'USERSANDTEAM',
        label: this.i18n.i18nLng()['USERSANDTEAM'],
        // icon: 'pi pi-users',
        linkIndex: 1,
        active: this.activeProfileId === 'USERSANDTEAM',
      },
      {
        id:'CONTRACTS',
        i18nLabelKey: 'CONTRACTS',
        label: this.i18n.i18nLng()['CONTRACTS'],
        // icon: 'pi pi-file-check',
        linkIndex: 2,
        active: this.activeProfileId === 'CONTRACTS',
      },
      {
        id:'PRICING',
        i18nLabelKey: 'PRICING',
        label: this.i18n.i18nLng()['PRICING'],
        // icon: 'pi pi-file-check',
        linkIndex: 3,
        active: this.activeProfileId === 'PRICING',
      },
      {
        id:'BILLING',
        i18nLabelKey: 'BILLING',
        label: this.i18n.i18nLng()['BILLING'],
        // icon: 'pi pi-file-check',
        linkIndex: 4,
        active: this.activeProfileId === 'BILLING',
      },
        */
      {
        id:'CHANGEPASSWORD',
        i18nLabelKey: 'CHANGEPASSWORD',
        label: this.i18n.i18nLng()['CHANGEPASSWORD'],
        icon: 'pi pi-external-link',
        linkIndex: 1,
        active: this.activeProfileId === 'CHANGEPASSWORD',
        url: this.runtimeConfig.zbvChangePasswordUrl,
        target: '_blank',
      },
    ];
    this.menuItems.push(
      {
        id:'LOGOUT',
        i18nLabelKey: 'LOGOUT',
        label: this.i18n.i18nLng()['LOGOUT'],
        icon: 'pi pi-sign-out',
        linkIndex: 2,
        active: this.activeProfileId === 'LOGOUT',
        command: () => {
          this.authService.logoutZBV();
        },
      },
    )
    this.activeMenuItem = this.menuItems.find(item => item.active);
  }

  activateMenuItem(menuItem: SpsMenuItem) {
    if (menuItem !== this.activeMenuItem) {
      this.activeMenuItem.active = false;
      menuItem.active = true;
      this.activeMenuItem = menuItem;
      this.activeProfileId = menuItem.id;
    }
  }

  /**
   * callback function for click on command menu item
   */
  commandItemClick(event: Event, item: SpsMenuItem) {
    if (item.disabled) {
      event.preventDefault();
      return true;
    }
    /** execute command callback function */
    if (item.command) {
      item.command({originalEvent: event, item: item});
    }
  }


  /**
   * Keyborad-Control for Dialog-MenuItems
   * @param event
   */
  onKeyDown(event: KeyboardEvent) {
    const currentIndex = this.links.findIndex(el => el === document.activeElement);
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      (event.target as HTMLElement).click();
    }
    if (event.key === 'ArrowDown') {
      let nextLinkIndex: number = currentIndex + 1;
      if (nextLinkIndex > this.maxLinkIndex) {
        nextLinkIndex = 0;
      }
      this.links[nextLinkIndex].focus();
    }
    if (event.key === 'ArrowUp') {
      let previousLinkIndex: number = currentIndex - 1;
      if (previousLinkIndex === -1) {
        previousLinkIndex = this.maxLinkIndex;
      }
      this.links[previousLinkIndex].focus();
    }
  }

  /**
   * callback-function to enable/disable Save-Button
   * @param enabled
   */
  enableSaveButton(enabled: boolean) {
    this.saveEnabled = enabled;
  }

  /**
   * save the data for the specific profile-page
   */
  saveProfileData() {

    // TODO

  }
}
